module.exports = __webpack_public_path__ + "img/Download_Replay.436a4656.png";